import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'opt-wp-change-request',
  templateUrl: './wp-change-request.component.html',
  styleUrls: ['./wp-change-request.component.scss']
})
export class WpChangeRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
